import { Component } from '@angular/core';

@Component({
  selector: 'app-data-not-found',
  templateUrl: './data-not-found.component.html',
  styleUrls: ['./data-not-found.component.scss'],
  standalone: false,
})
export class DataNotFoundComponent {
  constructor() {}
}
